<app-products [forJSPage]="true"></app-products>